import { AccountStatusEnum } from '../constants/account-info.constant';

export const ORGANIZATION_ROLE_ADMIN = 'ADMIN';

type OrganizationRole = typeof ORGANIZATION_ROLE_ADMIN;

export enum AccountTier {
  TIER1 = 'TIER1',
  TIER2 = 'TIER2',
  TIER3 = 'TIER3',
}

export interface IAccountInformation {
  id: string;
  accountNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: AccountStatusEnum;
  organizationVatNumber: string;
  taxNumber: string;
  registrationType: number;
  activeContext?: string;
  phone?: string;
  metroCard?: string;
  organizationName?: string;
  organizationRoles?: OrganizationRole[];
  isFirstLogin?: boolean;
  tier?: AccountTier;
  hasSplitPaymentObligation?: boolean;
  hashedIdamUserId?: string;
  hashedActiveContextId?: string;
  hashedPersonCdmId?: string;
  isSubsidiary?: boolean;
  accountType?: AccountTypeInfo;
  parentBusiness?: IParentBusinessInfo;
  hashedEmail?: string;
}

export interface IAccountInformationV2 {
  type: AccountType;
  customer?: IAccountInformation;
  employee?: IEmployee;
  scopes?: string[];
}

export interface IEmployee {
  idamId: string;
  email: string;
  tenant: string;
  fullName: string;
  employeeId: string;
  impersonationSessionId: string;
  canImpersonateCustomer: boolean;
}

export interface IParentBusinessInfo {
  accountId: string;
  email: string;
  accountNumber: string;
  billingAddress?: {
    addresseeFirstName: string;
    addresseeLastName: string;
    addresseeCompany: string;
    addressSupplement: string;
    postalCode: string;
    country: string;
    city: string;
    province: string;
    street: string;
    buildingNumber: string;
  };
  config?: {
    isPurchaseOrderNrRequired?: boolean;
    minAllowedOrderAmount?: string;
    minManualApprovalAmount?: string;
  };
}

export interface ISharePaymentLinkId {
  sharedPaymentLinkId: string;
}

export enum AccountType {
  EMPLOYEE = 'employee',
  CUSTOMER = 'customer',
  EMPLOYEE_AS_CUSTOMER = 'employee_as_customer',
}

export enum AccountTypeInfo {
  REGULAR_BUYER = 'REGULAR_BUYER',
  SUBSIDIARY = 'SUBSIDIARY',
  HEAD_QUARTER = 'HEAD_QUARTER',
}

export enum AccountInfoFetchingStatus {
  LOADING = 'loading',
  FAILED = 'failed',
}

export interface IAccountPersonalInformation {
  activeContext: string;
}

export const userTypeByAccountType = {
  [AccountType.CUSTOMER]: 'CUST',
  [AccountType.EMPLOYEE]: 'EMP',
  [AccountType.EMPLOYEE_AS_CUSTOMER]: 'EMP',
};
